import { WarningFilled } from '@ant-design/icons'
import { Button } from 'antd'
import styled from '@emotion/styled'
import CenterContainer from '../components/CenterContainer'

const Heading = styled.h2`
  margin-top: 1em;
`

const TryButton = styled(Button)`
  margin-top: 2em;
  background-color: #FF691D;
  border-color: #FF691D;

  &:active,
  &:hover,
  &:focus {
    background-color: #FF691D;
    border-color: #FF691D;
  }
`

const Maintenance = () => {
  return (
    <CenterContainer>
      <div>
        <WarningFilled style={{ color: '#FF691D', fontSize: '4em' }} />
        <Heading>
          <b>ขออภัย</b> เรากำลังปรับปรุงระบบเพื่อประสบการณ์การสมัครที่ดีขึ้น
          กรุณารอสักครู่
        </Heading>
        <TryButton
          onClick={() => {
            window.location.reload()
          }}
          shape="round"
          size="large"
          type="primary"
        >
          ลองใหม่อีกครั้ง
        </TryButton>
      </div>
    </CenterContainer>
  )
}

export default Maintenance
